import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { services } from '../mock';
import { Smartphone, Laptop, Monitor, Code, Cpu, Wrench, Check, MessageCircle } from 'lucide-react';

const iconMap = {
  Smartphone,
  Laptop,
  Monitor,
  Code,
  Cpu,
  Wrench
};

export const Services = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/543586019885', '_blank');
  };

  return (
    <div className="min-h-screen py-20 px-4">
      <div className="container mx-auto">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-cyan-400 to-emerald-400 bg-clip-text text-transparent">
            Servicios Profesionales
          </h1>
          <p className="text-xl text-slate-300">
            Soluciones completas para todos tus dispositivos electrónicos
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <Card key={service.id} className="bg-slate-800/50 backdrop-blur-sm border-slate-700 hover:border-cyan-500/50 transition-all duration-300 hover:scale-[1.02]">
                <CardHeader>
                  <div className="w-16 h-16 rounded-lg bg-gradient-to-br from-cyan-500/20 to-emerald-500/20 flex items-center justify-center mb-4">
                    <Icon className="h-8 w-8 text-cyan-400" />
                  </div>
                  <CardTitle className="text-white text-2xl">{service.title}</CardTitle>
                  <CardDescription className="text-slate-400 text-base">{service.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    <h4 className="text-cyan-400 font-semibold mb-3">Incluye:</h4>
                    {service.features.map((feature) => (
                      <div key={`${service.title}-${feature}`} className="flex items-start gap-3">
                        <div className="w-5 h-5 rounded-full bg-cyan-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <Check className="h-3 w-3 text-cyan-400" />
                        </div>
                        <span className="text-slate-300">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <Button 
                    className="w-full mt-6 bg-gradient-to-r from-cyan-600 to-emerald-600 hover:from-cyan-500 hover:to-emerald-500 transition-all duration-300"
                    onClick={handleWhatsAppClick}
                  >
                    <MessageCircle className="mr-2 h-4 w-4" />
                    Consultar Precio
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Why Choose Us */}
        <div className="max-w-4xl mx-auto">
          <Card className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-sm border-slate-700">
            <CardContent className="p-8 md:p-12">
              <h2 className="text-3xl font-bold text-white mb-6 text-center">¿Por Qué Elegirnos?</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-cyan-500/20 flex items-center justify-center flex-shrink-0">
                    <Check className="h-5 w-5 text-cyan-400" />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold mb-1">Diagnóstico Gratuito</h3>
                    <p className="text-slate-400">Evaluamos tu dispositivo sin costo</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-cyan-500/20 flex items-center justify-center flex-shrink-0">
                    <Check className="h-5 w-5 text-cyan-400" />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold mb-1">Garantía 30 Días</h3>
                    <p className="text-slate-400">Todas las reparaciones garantizadas</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-cyan-500/20 flex items-center justify-center flex-shrink-0">
                    <Check className="h-5 w-5 text-cyan-400" />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold mb-1">Repuestos Originales</h3>
                    <p className="text-slate-400">Trabajamos con componentes de calidad</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-cyan-500/20 flex items-center justify-center flex-shrink-0">
                    <Check className="h-5 w-5 text-cyan-400" />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold mb-1">Servicio Rápido</h3>
                    <p className="text-slate-400">Mayoría de reparaciones en 24-48hs</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <h2 className="text-3xl font-bold text-white mb-4">¿Necesitás Reparar tu Dispositivo?</h2>
          <p className="text-slate-300 mb-6">Contactanos por WhatsApp y te respondemos al instante</p>
          <Button 
            size="lg" 
            className="bg-gradient-to-r from-cyan-600 to-emerald-600 hover:from-cyan-500 hover:to-emerald-500 text-lg px-8 py-6 transition-all duration-300 hover:scale-105"
            onClick={handleWhatsAppClick}
          >
            <MessageCircle className="mr-2 h-5 w-5" />
            Contactar por WhatsApp
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Services;